import { getProduitAssocie } from '@/api/devis/index';
import { PRODUIT_ID } from '@/configuration/devisConf';
import * as produitConfig from '@/configuration/produitConf';
import { calculArrondi } from '@/services/general/arrondiCalcul';

async function genererProduitAssocies(produitsAssocies, info, liaisonsTarif) {
  if (!info.id || !info.prixUnitaire) return;
  if (liaisonsTarif === null) return;
  if (info.idProduit === PRODUIT_ID) {
    const liaison = liaisonsTarif.find(el => el.libelle.toLowerCase().includes(info.label));
    if (liaison) {
      produitsAssocies.liaisonsTarif.push({
        ...liaison,
        prixUnitaire: info.prixUnitaire,
        quantite: info.quantite,
        uniteVente: info.uniteVente,
      });
      return;
    }
  }

  const res = (await getProduitAssocie(info.id)).data.result;

  if (!res) return;

  produitsAssocies.liaisonsTarif.push({
    estParent: false,
    id: '',
    libelle: res.libelle,
    prixUnitaire: info.prixUnitaire,
    produitEnfant: res,
    produitEnfantId: res.id,
    quantite: info.quantite,
    uniteVente: info.uniteVente,
  });
}

export async function gestionLiaisonsTarifProduitsAssocies(
  produitsAssocies, produit, listIdProduits, typeProduit) {
  if (!produitsAssocies) return;
  const prixProduit = {
    tarif: null,
    tlpe: undefined,
    frais: undefined,
    pose: undefined,
  };
  produitsAssocies.quantite = 1;
  const infoProduit = {
    quantite: {
      tlpe: 1,
      frais: 1,
      pose: 1,
    },
    uniteVente: {
      tlpe: 'Unite',
      frais: 'Unite',
      pose: 'Unite',
    },
  };
  if (typeProduit === produitConfig.CATEGORIE_UNITAIRE) {
    prixProduit.tarif = produit.extensionOpportunite.tarifAnnuel
      ? produit.extensionOpportunite.tarifAnnuel : produit.extensionOpportunite.tarifNet;
    prixProduit.tlpe = produit.extensionOpportunite.taxeMunicipale
      ? produit.extensionOpportunite.taxeMunicipale : 0;
    prixProduit.frais = produit.extensionOpportunite.fraisTechnique
      ? produit.extensionOpportunite.fraisTechnique : 0;
    prixProduit.pose = produit.extensionOpportunite.tarifDePose
      ? produit.extensionOpportunite.tarifDePose : 0;
  }
  if (typeProduit === produitConfig.CATEGORIE_REGROUPEMENT) {
    prixProduit.tarif = produit.extensionOpportunite.tarifHT
      ? produit.extensionOpportunite.tarifHT : produit.extensionOpportunite.tarifNet;
    prixProduit.tlpe = produit.extensionOpportunite.taxeMunicipale
      ? produit.extensionOpportunite.taxeMunicipale : 0;
    prixProduit.frais = produit.extensionOpportunite.tarifImpression
      ? produit.extensionOpportunite.tarifImpression : 0;
    prixProduit.pose = produit.extensionOpportunite.tarifDePose
      ? produit.extensionOpportunite.tarifDePose : 0;
    if (produit.tarifUnitaire) {
      produitsAssocies.quantite = produit.extensionOpportunite.facesSouhaitees;
      produitsAssocies.uniteVente = 'Face';
      produitsAssocies.tarifUnitaire = true;
      prixProduit.tarif /= produit.extensionOpportunite.facesSouhaitees;
      prixProduit.tlpe /= produit.extensionOpportunite.facesSouhaitees;
      prixProduit.frais /= produit.extensionOpportunite.facesSouhaitees;
      prixProduit.pose /= produit.extensionOpportunite.facesSouhaitees;
      infoProduit.quantite.frais = produit.extensionOpportunite.facesSouhaitees;
      infoProduit.quantite.pose = produit.extensionOpportunite.facesSouhaitees;
      infoProduit.uniteVente.frais = 'Face';
      infoProduit.uniteVente.pose = 'Face';
      if (!produit.calculAutoTlpe) {
        infoProduit.quantite.tlpe = produit.extensionOpportunite.facesSouhaitees;
        infoProduit.uniteVente.tlpe = 'Face';
      }
    }
  }
  if (typeProduit === produitConfig.CATEGORIE_REGROUPEMENT_LC) {
    prixProduit.tarif = produit.extensionOpportunite.tarifBrut
      ? produit.extensionOpportunite.tarifBrut : produit.extensionOpportunite.tarifNet;
    prixProduit.tlpe = produit.extensionOpportunite.taxeMunicipale
      ? produit.extensionOpportunite.taxeMunicipale : 0;
    prixProduit.frais = produit.extensionOpportunite.fraisTechnique
      ? produit.extensionOpportunite.fraisTechnique : 0;
    prixProduit.pose = produit.extensionOpportunite.tarifDePose
      ? produit.extensionOpportunite.tarifDePose : 0;
  }
  if (typeProduit === produitConfig.CATEGORIE_ECRAN_NUMERIQUE) {
    prixProduit.tarif = produit.extensionOpportunite.tarifHt
      ? produit.extensionOpportunite.tarifHt : 0;
    prixProduit.tlpe = produit.extensionOpportunite.taxeMunicipale
      ? produit.extensionOpportunite.taxeMunicipale : 0;
    prixProduit.frais = produit.extensionOpportunite.fraisAdserving
      ? produit.extensionOpportunite.fraisAdserving : 0;
    produitsAssocies.quantite = produit.extensionOpportunite.quantite;
  }
  if (typeProduit === produitConfig.CATEGORIE_REGROUPEMENT_NUMERIQUE) {
    prixProduit.tarif = produit.tarifBrut ? produit.tarifBrut :
      produit.extensionOpportunite.tarifNet;
    prixProduit.tlpe = produit.extensionOpportunite.taxeMunicipale
      ? produit.extensionOpportunite.taxeMunicipale : 0;
    prixProduit.frais = produit.extensionOpportunite.fraisAdserving
      ? produit.extensionOpportunite.fraisAdserving : 0;
  }
  produitsAssocies.prixUnitaire = calculArrondi(prixProduit.tarif, 5);
  produitsAssocies.remise = -1 * calculArrondi(produit.extensionOpportunite.remise, 5);
  const liaisonsTarif = produitsAssocies.liaisonsTarif;
  produitsAssocies.liaisonsTarif = [];
  await genererProduitAssocies(produitsAssocies, {
    id: listIdProduits.tlpe,
    prixUnitaire: calculArrondi(prixProduit.tlpe, 5),
    label: 'tlpe',
    idProduit: listIdProduits.produit,
    quantite: infoProduit.quantite.tlpe,
    uniteVente: infoProduit.uniteVente.tlpe,
  }, liaisonsTarif);
  await genererProduitAssocies(produitsAssocies, {
    id: listIdProduits.fraisTechnique,
    prixUnitaire: calculArrondi(prixProduit.frais, 5),
    label: 'fraisTechnique',
    idProduit: listIdProduits.produit,
    quantite: infoProduit.quantite.frais,
    uniteVente: infoProduit.uniteVente.frais,
  }, liaisonsTarif);
  await genererProduitAssocies(produitsAssocies, {
    id: listIdProduits.pose,
    prixUnitaire: calculArrondi(prixProduit.pose, 5),
    label: 'pose',
    idProduit: listIdProduits.produit,
    quantite: infoProduit.quantite.pose,
    uniteVente: infoProduit.uniteVente.pose,
  }, liaisonsTarif);
}

export const NOTHING = '';



// WEBPACK FOOTER //
// ./src/services/devis/gestionProduitsAssocies.js